import { render, staticRenderFns } from "./export_sxzj_teacher_all.vue?vue&type=template&id=8bda5976&"
import script from "./export_sxzj_teacher_all.vue?vue&type=script&lang=js&"
export * from "./export_sxzj_teacher_all.vue?vue&type=script&lang=js&"
import style0 from "./export_sxzj_teacher_all.vue?vue&type=style&index=0&id=8bda5976&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports